import React, {useState} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import { IdCreditRequestModal } from '../CustomerCards/modals/id-credit-request/IdCreditRequestModal';


interface IRoundIndicatorProps {
    outerRadius: number;
    innerRadius: number;
    fillPercentage: number;
    fillText?: string;
    fillTextMeasure?: string;
    fillTextClassName?: string;
    fillColor: string;
    description?: string;
    descriptionSecondLine?: string;
    btnTitle?: string;
    btnTitleSecondLine?: string;
    doubleIndicator?: boolean;
    doubleStrokeColor?: string;
    doubleCircleColor?: string;
    innerRadiusFullShadow?: boolean;
    innerRadiusShadowColor?: string;
    backgroundColor?: string;
    showfillPercentage?: boolean;
    addArrow?: boolean;
    isTooltip?: boolean;
    tooltipText?: string;
    showIcon?: boolean;
    iconType?: string;
    collectTitle?: string;
    collectSecondLine?: string;
    middleIndicator?: boolean;
    runningCoffeeCount?: number;
    classNames?: string;
}

export function RoundIndicator(props: IRoundIndicatorProps) {
    const [isModalVisible, setModalVisible] = useState(false);
    const fillDegrees = Math.min(360 * (Math.max(1, props.fillPercentage) / 100), 359.95);
    function generateArcPathSmall(
            progressState: number,
            outerRadius: number,
            innerRadius: number
        ): string | undefined {
            const xStart = outerRadius;
            const yStart = outerRadius - innerRadius;
            const startingPosition = xStart + ' ' + yStart;

            const shape = innerRadius + ' ' + innerRadius;

            const isSweeping = (progressState < 180) ? 0 : 1;
            const isBeginning = (progressState === 0) ? 1 : 0;
            const specialStates = ' 0 ' + isSweeping + ' ' + isBeginning + ' ';

            const pii = 3.14159;
            const toRadian = pii / 180;
            let xPos = Math.sin((progressState) * toRadian) * (-1 * innerRadius) + outerRadius;
            let yPos = Math.sin((270 + progressState) * toRadian) * innerRadius + outerRadius;

            let arcPath: string = 'M ' + startingPosition + ' A ' + shape + specialStates + xPos.toFixed(2) + ' ' + yPos.toFixed(2);

            return arcPath;
    }

    function doubleindicator() {
        if(props.doubleIndicator) {
            return (
                <path
                d={generateArcPathSmall(fillDegrees, props.outerRadius, props.innerRadius - 5)}
                stroke={props.doubleStrokeColor} 
                strokeWidth='5' 
                fill={props.doubleCircleColor}
                />
            )
        }
    }

    const diameter = props.outerRadius * 2;
    const descriptionYPosition = props.outerRadius + 20;
    const titleYPosition = props.outerRadius - 10;

    const popoverTooltip = (
        <Tooltip id="round-indicator-tooltip">
            <p>{props.tooltipText}</p>
        </Tooltip>
    );

    /* TO-DO: collectedSum from loyalty card */
    const collectedSum = props.runningCoffeeCount || 0;
    
    const CollectedAmount = () => {
        return (
            <>
            <g fill="none" style={{transform: 'scale(1.52) translate(3px, 3px)'}}>
                {collectedSum > 0 ? <path d="M83 39.7899C81.4485 20.1886 65.8115 4.55159 46.2101 3.00006" stroke="#FFE608" strokeWidth="3"/>  : <path d="M83 39.7899C81.4485 20.1886 65.8115 4.55159 46.2101 3.00006" stroke="#33A3AE" strokeWidth="3"/>}
                {collectedSum > 1 ? <path d="M83 46.2102C81.4485 65.8115 65.8115 81.4485 46.2101 83" stroke="#FFE608" strokeWidth="3"/> : <path d="M83 46.2102C81.4485 65.8115 65.8115 81.4485 46.2101 83" stroke="#33A3AE" strokeWidth="3"/>}
                {collectedSum > 2 ? <path d="M39.7899 83C20.1885 81.4485 4.55153 65.8115 3 46.2102" stroke="#FFE608" strokeWidth="3" />: <path d="M39.7899 83C20.1885 81.4485 4.55153 65.8115 3 46.2102" stroke="#33A3AE" strokeWidth="3" />}
                {collectedSum > 3 ? <path d="M3 39.7899C4.55153 20.1886 20.1885 4.55159 39.7899 3.00006" stroke="#FFE608" strokeWidth="3" /> : <path d="M3 39.7899C4.55153 20.1886 20.1885 4.55159 39.7899 3.00006" stroke="#33A3AE" strokeWidth="3" />}
            </g>
            {props.iconType === 'coffee' &&
            <g fill="#00A5B0" style={{ transform: 'translate(27px, 27px)' }}>
                {/* 27 = dashboard.svg.width - coffee.svg.width / 2 */}
                <path d="M43.912 43.917c1.842 0 3.542.708 4.817 1.983a6.746 6.746 0 0 1 1.983 4.817 6.746 6.746 0 0 1-1.983 4.816 6.746 6.746 0 0 1-4.817 1.984 6.746 6.746 0 0 1-4.816-1.984 6.746 6.746 0 0 1-1.984-4.816c0-1.842.709-3.542 1.984-4.817a6.746 6.746 0 0 1 4.816-1.983Zm0-1.842a8.586 8.586 0 0 0-8.641 8.642 8.586 8.586 0 0 0 8.641 8.641 8.586 8.586 0 0 0 8.642-8.641 8.586 8.586 0 0 0-8.642-8.642Z" />
                <path fillRule="evenodd" clipRule="evenodd" d="M40.229 56.383s2.975-1.275 4.25-2.125c0 0 .567-1.133 1.558-3.4 1.275-2.833 3.4-3.825 12.042-7.791 0 0-5.1-.567-14.308 3.4 0 0-.142 0-.142.141-.425.85-2.975 6.234-3.4 9.775Z" />
                <path d="M34.138 20.117c.566 2.833 3.683 4.108 3.966 4.25l.992-2.55c-.567-.284-2.125-1.134-2.408-2.267-.142-.85.283-1.842 1.275-2.833 1.841-1.984 2.55-3.825 2.125-5.525-.709-2.692-3.684-3.967-3.967-4.109l-.992 2.55s1.984.85 2.267 2.125c.283.992-.567 2.125-1.275 2.834-1.7 1.983-2.408 3.683-1.983 5.525ZM41.504 20.117c.567 2.833 3.683 4.108 3.967 4.25l.991-2.55c-.566-.284-2.125-1.134-2.266-2.267-.142-.85.283-1.842 1.275-2.833 1.7-1.842 2.408-3.684 1.983-5.384-.708-2.833-3.683-4.108-3.967-4.25l-.991 2.55s1.983.85 2.266 2.125c.284.992-.566 2.125-1.275 2.834-1.7 1.983-2.408 3.683-1.983 5.525ZM48.87 20.117c.567 2.833 3.684 4.108 3.967 4.25l.992-2.55c-.567-.284-2.125-1.134-2.267-2.267-.141-.85.284-1.842 1.275-2.833 1.7-1.842 2.409-3.684 1.984-5.384-.709-2.833-3.684-4.108-3.967-4.25l-.992 2.55s1.984.85 2.267 2.125c.283.992-.567 2.125-1.275 2.834-1.7 1.983-2.408 3.683-1.983 5.525ZM29.746 54.967l1.417 19.691c0 1.134.991 1.984 2.125 1.984h21.391c1.133 0 1.983-.85 2.125-1.984l1.417-19.691h-2.55c-1.842 4.675-6.233 7.933-11.617 7.933-5.242 0-9.775-3.4-11.617-7.933h-2.691ZM60.063 28.192h-32.3l1.274 17.85h3.259c1.842-4.675 6.233-7.934 11.475-7.934s9.775 3.259 11.475 7.934h3.258l1.559-17.85Z" />
            </g>}
            {props.iconType === 'hamburger' &&
            <g fill="#00A5B0" style={{ transform: 'translate(38px, 38px)' }}>
                {/* 38 = dashboard.svg.width - hamburger.svg.width / 2 */}
                <path d="M58 34.5556C58 37.3922 55.686 39.6667 52.8 39.6667H11.2C9.82087 39.6667 8.49823 39.1282 7.52304 38.1697C6.54786 37.2111 6 35.9111 6 34.5556C6 33.2 6.54786 31.9 7.52304 30.9415C8.49823 29.9829 9.82087 29.4444 11.2 29.4444H34.6L41.1 34.5556L47.6 29.4444H52.8C54.1791 29.4444 55.5018 29.9829 56.477 30.9415C57.4521 31.9 58 33.2 58 34.5556ZM32 9C8.6 9 8.6 24.3333 8.6 24.3333H55.4C55.4 24.3333 55.4 9 32 9ZM8.6 47.3333C8.6 51.5756 12.084 55 16.4 55H47.6C51.916 55 55.4 51.5756 55.4 47.3333V44.7778H8.6V47.3333Z"/>
            </g>}
            </>
        );
    };

    return (
        <>
        <div className={'dashboard__item ' + (props.classNames || '')} onClick={() => props.btnTitle ? setModalVisible(true) : undefined} style={{width:diameter,height:diameter, zIndex: (props.middleIndicator === true ? 1 : 0)}}>
            <svg
                className={`dashboard__indicator${ props.btnTitle ? " dashboard__indicator--pointer" : ''}`}
                viewBox={'0 0 ' + diameter + ' ' + diameter}
                width='100%'
                height='100%'
                preserveAspectRatio="xMidYMid meet"
            >
            <defs>
                <linearGradient id="primary-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%"   stopColor="#FEE626"/>
                <stop offset="100%" stopColor="#FFFFFF"/>
                </linearGradient>
            </defs>
            <circle cx={props.outerRadius}
                    cy={props.outerRadius}
                    r={props.outerRadius}
                    fill={props.backgroundColor ? props.backgroundColor : '#008C9A'}
            />
            {
                props.innerRadiusFullShadow &&
                <path
                    d={generateArcPathSmall(359.9, props.outerRadius, props.innerRadius,)}
                    className="dashboard__inner-radius--shadow"
                    strokeWidth='5'
                    fill='transparent'
                    style={{stroke: (props.innerRadiusShadowColor !== null ? props.innerRadiusShadowColor : "#b2e6fe")}}
                />
            }
            {
                props.showfillPercentage !== false &&
                <path
                d={generateArcPathSmall(fillDegrees, props.outerRadius, props.innerRadius,)}
                stroke={props.fillColor}
                strokeWidth='5'
                fill='transparent'
            /> 
            }
            { 
                props.showIcon && <CollectedAmount/>
            }
            {doubleindicator()}
            {
                props.showfillPercentage !== false &&
                    <text
                        x={props.outerRadius}
                        y={props.outerRadius}
                        className={'dashboard__text--big ' + (props.fillTextClassName || '')}
                        textAnchor='middle'>
                        {props.fillTextMeasure ?
                            <><tspan dy="1" className="dashboard__text--medium">{props.fillText}&nbsp;</tspan>
                            <tspan dy="-1" className="dashboard__text--small">{props.fillTextMeasure}</tspan></>
                            : props.fillText
                        }
                    </text>
            }
            {
                props.showfillPercentage === false && props.fillText && 
                <text
                    x={props.outerRadius}
                    y={props.outerRadius}
                    className={'dashboard__text--big ' + (props.fillTextClassName || '')}
                    textAnchor='middle'>
                    {props.fillText}
                </text>
            }
            {
                props.description !== null &&
                <text
                    x={props.outerRadius}
                    y={descriptionYPosition}
                    className="dashboard__text--small"
                    textAnchor='middle'>
                    {props.description}
                </text>
            }
            {
                props.descriptionSecondLine &&
                <text
                    x={props.outerRadius}
                    y={descriptionYPosition+ 14}
                    className="dashboard__text--small"
                    textAnchor='middle'>
                    {props.descriptionSecondLine}
                </text>
            }
            {
                props.btnTitle &&
                <>
                    <text
                        x={props.outerRadius}
                        y={titleYPosition}
                        className="dashboard__title--small"
                        textAnchor='middle'>
                        {props.btnTitle}
                    </text>
                </>
            }
            {
                props.btnTitleSecondLine &&
                <text
                    x={props.outerRadius}
                    y={titleYPosition + 20}
                    className="dashboard__title--big"
                    textAnchor='middle'>
                    {props.btnTitleSecondLine}
                </text>
            }
            {
                props.btnTitle &&
                <path className="dashboard__title--arrow" d="M16.1445 5.51634L15.8078 5.88457C15.5846 6.12863 15.5846 6.52436 15.8078 6.76847L19.8043 11.1145H1.90493C1.58935 11.1145 1.3335 11.3944 1.3335 11.7395V12.2604C1.3335 12.6055 1.58935 12.8854 1.90493 12.8854H19.8043L15.8078 17.2314C15.5846 17.4755 15.5846 17.8712 15.8078 18.1153L16.1445 18.4835C16.3676 18.7276 16.7294 18.7276 16.9526 18.4835L22.4995 12.4419C22.7226 12.1978 22.7226 11.8021 22.4995 11.558L16.9526 5.51634C16.7294 5.27222 16.3676 5.27222 16.1445 5.51634Z" fill="#293846"/>
            }
            {
                props.collectTitle &&
                <text
                    x={props.outerRadius}
                    y={titleYPosition + 5}
                    className="dashboard__collect--small"
                    textAnchor='middle'>
                    {props.collectTitle}
                </text>
            }
            {
                props.collectSecondLine &&
                <text
                    x={props.outerRadius}
                    y={titleYPosition + 22}
                    className="dashboard__collect--small"
                    textAnchor='middle'>
                    {props.collectSecondLine}
                </text>
            }
            <use xlinkHref="#symbol-id"></use>
        </svg>
        {props.isTooltip &&
            <OverlayTrigger trigger="click" placement="top" overlay={popoverTooltip}>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" className="dashboard__indicator-tooltip">
                    <rect width="34" height="34" rx="17" fill="#008C9A"/>
                    <path d="M17 3.875C9.75195 3.875 3.875 9.75195 3.875 17C3.875 24.248 9.75195 30.125 17 30.125C24.248 30.125 30.125 24.248 30.125 17C30.125 9.75195 24.248 3.875 17 3.875ZM17 27.8984C10.9824 27.8984 6.10156 23.0176 6.10156 17C6.10156 10.9824 10.9824 6.10156 17 6.10156C23.0176 6.10156 27.8984 10.9824 27.8984 17C27.8984 23.0176 23.0176 27.8984 17 27.8984Z" fill="#FFE608"/>
                    <path d="M15.5938 11.8438C15.5938 12.2167 15.7419 12.5744 16.0056 12.8381C16.2694 13.1018 16.627 13.25 17 13.25C17.373 13.25 17.7306 13.1018 17.9944 12.8381C18.2581 12.5744 18.4062 12.2167 18.4062 11.8438C18.4062 11.4708 18.2581 11.1131 17.9944 10.8494C17.7306 10.5857 17.373 10.4375 17 10.4375C16.627 10.4375 16.2694 10.5857 16.0056 10.8494C15.7419 11.1131 15.5938 11.4708 15.5938 11.8438V11.8438ZM17.7031 15.125H16.2969C16.168 15.125 16.0625 15.2305 16.0625 15.3594V23.3281C16.0625 23.457 16.168 23.5625 16.2969 23.5625H17.7031C17.832 23.5625 17.9375 23.457 17.9375 23.3281V15.3594C17.9375 15.2305 17.832 15.125 17.7031 15.125Z" fill="#FFE608"/>
                </svg>
            </OverlayTrigger>
        }
        </div>
        {
            isModalVisible ?
            <IdCreditRequestModal
                handleConfirmReject={() => setModalVisible(false)}
                handleConfirmSubmit={() => {setModalVisible(false)}}
            /> 
            : null
        }
    </>
    )
}